import { render, staticRenderFns } from "./consumeRecord.vue?vue&type=template&id=d8984528"
import script from "./consumeRecord.vue?vue&type=script&lang=ts"
export * from "./consumeRecord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports